import type { WhiteLabel } from '@skytech/types'

type StyleType = 'bg' | 'text' | 'border' | 'fill'
export const selectedStyleByWhiteLabel: Partial<Record<WhiteLabel, Record<StyleType, string>>> = {
  skytech: {
    // #6e6e6e
    border: 'border-[#6e6e6e]',
    bg: 'bg-[#6e6e6e]',
    fill: 'fill-[#6e6e6e]',
    text: 'text-[#6e6e6e]',
  },
  arp: { border: 'border-arp', bg: 'bg-arp', fill: 'fill-arp', text: 'text-arp' },
  mobit: { border: 'border-mobit', bg: 'bg-mobit', fill: 'fill-mobit', text: 'text-mobit' },
  evry: {
    border: 'border-tietoevry',
    bg: 'bg-tietoevry',
    fill: 'fill-tietoevry',
    text: 'text-tietoevry',
  },
  tietoevry: {
    border: 'border-tietoevry',
    bg: 'bg-tietoevry',
    fill: 'fill-tietoevry',
    text: 'text-tietoevry',
  },
  bechtle: {
    border: 'border-bechtle',
    bg: 'bg-bechtle',
    fill: 'fill-bechtle',
    text: 'text-bechtle',
  },
  csi: {
    border: 'border-csi-maroon',
    bg: 'bg-csi-maroon',
    fill: 'fill-csi-maroon',
    text: 'text-csi-maroon',
  },
  telia: { border: 'border-telia', bg: 'bg-telia', fill: 'fill-telia', text: 'text-telia' },
  elkjop: { border: 'border-elkjop', bg: 'bg-elkjop', fill: 'fill-elkjop', text: 'text-elkjop' },
  komplett: {
    border: 'border-komplett',
    bg: 'bg-komplett',
    fill: 'fill-komplett',
    text: 'text-komplett',
  },
  threeStepIT: {
    border: 'border-threeStepIT',
    bg: 'bg-threeStepIT',
    fill: 'fill-threeStepIT',
    text: 'text-threeStepIT',
  },
}

// Status styles
type Status = 'success' | 'warning' | 'error'
export const statusStyleByWhiteLabel: Partial<
  Record<WhiteLabel, Record<Status | 'info', { background: string; text: string }>>
> = {
  skytech: {
    success: { background: 'bg-green-500', text: 'text-green-600' },
    error: { background: 'bg-red-600', text: 'text-red-600' },
    warning: { background: 'bg-orange-100', text: 'text-orange-600' },
    info: { background: 'bg-blue-100', text: 'text-blue-600' },
  },
  threeStepIT: {
    success: { background: 'bg-threeStepIT-success', text: 'text-threeStepIT-success' },
    error: { background: 'bg-threeStepIT-failure', text: 'text-threeStepIT-failure' },
    warning: { background: 'bg-threeStepIT-warning-light', text: 'text-threeStepIT-warning' },
    info: { background: 'bg-threeStepIT-neutral/20', text: 'text-threeStepIT-neutral' },
  },
  telia: {
    success: { background: 'bg-telia-success', text: 'text-telia-success' },
    error: { background: 'bg-telia-red', text: 'text-telia-red' },
    warning: { background: 'bg-orange-100', text: 'text-orange-600' },
    info: { background: 'bg-blue-100', text: 'text-blue-600' },
  },
}

// CartCostBar styles
export const costBarBgStyleByWhiteLabel: Partial<Record<WhiteLabel, Record<Status, string>>> = {
  skytech: {
    success: 'bg-green-badge',
    warning: 'bg-[#f1c40f]',
    error: 'bg-red',
  },
  threeStepIT: {
    success: 'bg-threeStepIT-success',
    warning: 'bg-threeStepIT-warning',
    error: 'bg-threeStepIT-failure',
  },
}
// BuyOutOffering styles
export const lightSuccessBgStyleByWhiteLabel: Partial<Record<WhiteLabel, string>> = {
  skytech: 'bg-green-50',
  telia: 'bg-telia-success/10',
  threeStepIT: 'bg-threeStepIT-success/10',
}

export const radioBtnStyleByWhiteLabel: Partial<Record<WhiteLabel, string>> = {
  skytech: 'border-skytech-orange bg-skytech-orange/10',
  telia: 'bg-telia/10 border-telia',
  threeStepIT: 'bg-threeStepIT-seaMistPrimary border-threeStepIT',
  ice: 'border-[#ffb901]',
  mobit: 'border-mobit bg-mobit/10',
  evry: 'border-tietoevry bg-tietoevry/10',
  tietoevry: 'border-tietoevry bg-tietoevry/10',
  bechtle: 'border-bechtle bg-bechtle/10',
  csi: 'border-csi-maroon bg-csi-lightGray',
  arp: 'border-arp bg-arp/10',
  elkjop: 'border-elkjop ',
  komplett: 'border-komplett-lightYellow bg-komplett-lightYellow/10',
}
